module.exports = __webpack_public_path__ + "star-c618d5f4d5c4c07864edc52e48ba0aaf.svg";